import React, { useCallback, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { HandleAddSlotFrame, Slot, SlotFrameMode, SlotsFrameModule } from '@bcraft-frontend-lib/slots'

import SlotsIcon from 'components/slots/SlotsIcon/SlotsIcon'
import SlotsLayoutContent from 'components/slots/SlotsLayoutContent'

import { SlotPlace } from './redefinitions'

const getPlayMode = (place: string): SlotFrameMode => (place === 'free-spin' ? 'free-spin' : 'money')

const AddFrameSlotIcon: React.FC<{
  slot: Slot
  handleSlotAddFrame: HandleAddSlotFrame
}> = ({ slot, handleSlotAddFrame }) => {
  const { place, mode } = useParams<{ place?: string; mode?: SlotFrameMode }>()
  const playMode = useMemo(
    () => getPlayMode(place ?? (mode === 'free-spin' ? 'free-spin' : '')),
    [mode, place],
  )

  return (
    <SlotsIcon slot={slot} addFrame={() => () => handleSlotAddFrame({ slot, mode: playMode })} />
  )
}

export const SlotsFrameLayoutModule = () => {
  const successCallback = useCallback(() => {}, [])
  const errorCallback = useCallback(() => {}, [])

  return (
    <SlotsFrameModule<SlotPlace>
      type="multi"
      frameProps={{
        successCallback,
        errorCallback,
        renderSlotIcon: ({ slot, handleSlotAddFrame }) => (
          <AddFrameSlotIcon slot={slot} handleSlotAddFrame={handleSlotAddFrame} />
        ),
        renderSlotAddContent: ({ place, handleAddSlotFrame, filters }) => (
          <SlotsLayoutContent
            modal
            place={place}
            filters={filters}
            addFrame={(game: Slot) => () =>
              handleAddSlotFrame({ slot: game, mode: getPlayMode(place) })
            }
          />
        ),
      }}
    />
  )
}
